import styled from 'styled-components';
import type { FunctionComponent } from 'react';
import { paletteHelper, spacingHelper, Text, mediaHelper } from '@property.com.au/ui-kit';

import { useMediaGalleryCarousel } from '../../../../contexts/MediaGalleryCarouselContext/MediaGalleryCarouselContext';
import {
  MediaGalleryTimeline,
  MediaGalleryTimelineData,
} from '../MediaGalleryTimeline/MediaGalleryTimeline';
import { MediaItemV2 } from '../../../../../app-kit/components/Image/types';

const StyledMediaGalleryActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${spacingHelper('small')} ${spacingHelper('medium')};
  background: ${paletteHelper('backgroundOverlayStatic')};

  ${mediaHelper('mobile')} {
    flex-direction: column;
    gap: ${spacingHelper('extraSmall')};
  }
`;

const ImageCount = styled(Text).attrs(() => ({ variant: 'body02' }))`
  color: ${paletteHelper('textInverted')};
  width: 240px;
  ${mediaHelper('tablet')} {
    width: 156px;
  }
  ${mediaHelper('mobile')} {
    display: none;
  }
`;

const ImageCaption = styled(Text).attrs(() => ({ variant: 'body02' }))`
  color: ${paletteHelper('textInverted')};
  text-align: right;
  width: 240px;
  ${mediaHelper('tablet')} {
    width: 156px;
  }
  ${mediaHelper('mobile')} {
    display: none;
  }
`;

const MediaGalleryTimelineWrapper = styled.div``;

const MobileCaption = styled(Text).attrs(() => ({ variant: 'body02' }))`
  color: ${paletteHelper('textInverted')};
  display: none;
  text-align: center;

  ${mediaHelper('mobile')} {
    display: block;
  }
`;

interface MediaGalleryActionBarProps {
  timeline: MediaGalleryTimelineData[];
  galleryItems: MediaItemV2[];
}

export const MediaGalleryActionBar: FunctionComponent<MediaGalleryActionBarProps> = ({
  timeline,
  galleryItems,
}) => {
  const { currentSlide, swiper } = useMediaGalleryCarousel();
  if (!swiper || galleryItems.length === 0) return null;

  const captionV2 = galleryItems[currentSlide]?.image?.captionV2;

  return (
    <StyledMediaGalleryActionBar>
      <MobileCaption>{`${currentSlide + 1}/${swiper.virtual.slides.length} - ${captionV2}`}</MobileCaption>
      <ImageCount>{`${currentSlide + 1} / ${swiper.virtual.slides.length}`}</ImageCount>
      <MediaGalleryTimelineWrapper>
        <MediaGalleryTimeline timeline={timeline} />
      </MediaGalleryTimelineWrapper>
      <ImageCaption>{captionV2}</ImageCaption>
    </StyledMediaGalleryActionBar>
  );
};
